import React, { createContext, useContext, useState, useEffect } from 'react';
import tr from '../locales/tr.json';
import en from '../locales/en.json';

const languages = { tr, en };

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        const saved = localStorage.getItem('language');
        return saved || 'tr';
    });

    const t = (key) => {
        const keys = key.split('.');
        let value = languages[lang];
        for (const k of keys) {
            value = value?.[k];
        }
        return value || key;
    };

    useEffect(() => {
        localStorage.setItem('language', lang);
    }, [lang]);

    const toggleLanguage = () => setLang(prev => prev === 'tr' ? 'en' : 'tr');

    return (
        <LanguageContext.Provider value={{ lang, setLang, t, toggleLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
